<template lang="html">
  <div class="">
    <si-container>
      <v-flex xs12>
        <v-card>
          <v-card-title class="hedline">
            Assistance types
          </v-card-title>
          <v-card-text class="grey lighten-2 pa-4">
            <Container
              lock-axis="y"
              class="flex pa-0"
              drag-handle-selector=".si-drag-handle"
              @drop="onDropSection"
            >
              <Draggable
                v-for="(type, i) in types"
                :key="i"
              >
                <v-flex class="">
                  <v-card :id="type.id">
                    <v-layout
                      align-center
                      fill-height
                      ma-0
                      pa-2
                    >
                      <v-icon
                        left
                        class="cursor-move si-drag-handle"
                      >
                        drag_indicator
                      </v-icon>
                      <v-flex
                        shrink
                        pa-0
                        pr-2
                      >
                        <div class="subheading">
                          {{ type.name }} <span class="grey--text">{{ _$(type.price) }}</span>
                        </div>
                        <div class="caption grey--text">
                          {{ type.id }}
                        </div>
                      </v-flex>
                      <v-spacer />
                      <v-btn
                        text
                        color="grey"
                        @click="openPanel('panels', type.id)"
                      >
                        {{ panels[type.id] === 0 ? 'Done' : 'Edit' }}
                      </v-btn>
                    </v-layout>
                    <v-expansion-panels
                      v-model="panels[type.id]"
                      class="si-expansion-panel-flat"
                    >
                      <v-expansion-panel expand-icon="edit">
                        <v-expansion-panel-content>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12>
                                <SiInputText
                                  :ref="`${type.id}_title`"
                                  v-model="type.name"
                                  outlined
                                  autofocus
                                  hide-detailsx
                                  label="Name"
                                  @change="save"
                                />
                              </v-flex>
                              <v-flex xs12>
                                <SiInputText
                                  v-model="type.receiptText"
                                  outlined
                                  hide-detailsx
                                  label="Receipt text"
                                  @change="save"
                                />
                              </v-flex>
                              <v-flex
                                xs12
                                pa-0
                              >
                                <v-flex xs6>
                                  <SiInputNumber
                                    v-model="type.duration"
                                    outlined
                                    hide-detailsx
                                    label="Duration (hours)"
                                    @change="save"
                                  />
                                </v-flex>
                              </v-flex>
                              <v-flex xs6>
                                <SiInputCurrency
                                  v-model="type.price"
                                  outlined
                                  hide-detailsx
                                  cents
                                  label="Price"
                                  :error="type.price < ''"
                                  @change="save"
                                />
                              </v-flex>
                              <v-flex xs6>
                                <SiInputCurrency
                                  v-model="type.licensePrice"
                                  outlined
                                  hide-detailsx
                                  cents
                                  label="License price"
                                  :error="type.licensePrice < ''"
                                  @change="save"
                                />
                              </v-flex>

                              <v-flex
                                v-if="type.id !== 'standard'"
                                xs12
                                text-center
                              >
                                <SiDeleteButton
                                  title="Delete type?"
                                  :message="`Are you certain you want to delete this assistance type <strong>${type.id}</strong>?`"
                                  :challenge="type.id"
                                  @delete="deleteType(type.id)"
                                >
                                  <template #activator="{ on }">
                                    <v-btn
                                      text
                                      color="grey"
                                      v-on="on"
                                    >
                                      Delete
                                    </v-btn>
                                  </template>
                                </SiDeleteButton>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-flex>
              </Draggable>
            </Container>
          </v-card-text>
          <v-card-text>
            <SiVariableEditor
              variable-term="type id"
              prefix="assist_"
              :existing-variables="_unSortObject(types)"
              @variable="addType"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </si-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach } from 'lodash'
import { Container, Draggable } from 'vue-smooth-dnd'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import drag from '@/mixins/drag'

export default {
  components: { Container, Draggable },
  mixins: [ helpers, drag, binder ],
  data () {
    return {
      panels: {},
    }
  },
  computed: {
    ...mapGetters([ '_assistanceTypes' ]),
    types () {
      return this._sortObject(this._assistanceTypes)
    }
  },
  beforeMount () {
    this.$store.commit('set_appBarTitle', {title: 'Assistance types', icon: 'settings'})
    this.$bindRtdbStore('set_assistanceTypes', `assistance/_types`)
    // this.$bindStorexxx(rtdb.ref('assistance/_types'),'set_assistanceTypes')
  },
  methods: {
    addType (id) {
      rtdb.ref(`assistance/_types/${id}`).set({ id: id, price: 0, index: (this.types || []).length })
      forEach(this.panels, (panel, id) => {
        this.$set(this.panels, id, -1)
      })
      this.$set(this.panels, id, 0)
    },
    deleteType (id) {
      rtdb.ref(`assistance/_types/${id}`).set(null)
    },
    onDropSection (e) {
      this.types = this._applyDrag(this.types, e)
      this.types.forEach((x, i) => {
        x.index = i
      })
      this.save()
    },
    openPanel (panel, id) {
      if (this.panels[id] === 0) {
        this.panels[id] = -1
      } else {
        this.$set(this.panels, id, 0)
      }
    },
    save () {
      rtdb.ref('assistance/_types').set(this._unSortObject(this.types))
    }
  }
}
</script>

<style lang="css" scoped>

</style>
